import { push } from "react-router-redux"
import { put, takeLatest } from "redux-saga/effects"
import { AUTH_LOGOUT } from "./constants"

export function logout() {
  return {
    type: AUTH_LOGOUT,
  }
}

export function* doLogout() {
  yield put(push("/"))
}

export function* watchLogout() {
  yield takeLatest(AUTH_LOGOUT, doLogout)
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case AUTH_LOGOUT:
      return {
        ...state,
        username: null,
        authToken: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/redux/logout.js